'use client';

import { cn } from '@shared/shared-utils';
import { Button, Tooltip } from '../../../../components';
import { FC } from 'react';
import { AppRoute } from '../../../../../enums/enums';

type Properties = {
  className?: string;
  isMainPage?: boolean;
};

const HealthcareButton: FC<Properties> = ({
  className,
  isMainPage = false,
}) => {
  return (
    <Tooltip
      className="absolute right-0"
      content="I’m a Healthcare Professional"
    >
      <Button
        to={AppRoute.HCP}
        linkClassName={cn('hidden lg:flex', {
          'lg:hidden 2xl:flex': isMainPage,
        })}
        className={cn(
          'flex items-center gap-x-2 text-ogn-white font-roboto bg-ogn-blue rounded-full overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-ogn-bright-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
          className,
        )}
        variant="blue-white"
        rel="noopener noreferrer"
        aria-label="I’m a Healthcare Professional"
      >
        <span className="text-[min(1.1vw,16px)] text-nowrap font-roboto-condensed">
          I’m a Healthcare Professional
        </span>
      </Button>
    </Tooltip>
  );
};

export { HealthcareButton };
